import './NavItem.css';
export var button = '_bf74pw2-3-8-0';
export var isDisabled = '_bf74pw1-3-8-0';
export var isSelected = '_bf74pw0-3-8-0';